export const DELIVERY_ROUTE_STOP_LIMIT = 24
export const DELIVERY_ROUTE_STOP_LIMIT_MESSAGE = `Routes can include up to ${DELIVERY_ROUTE_STOP_LIMIT} stops.`
